import { Component, OnInit } from '@angular/core';
import { UiService } from '../core/services/ui.service';
import { sidebarActions } from './dummies-app.config';

@Component({
  selector: 'dummies-app',
  templateUrl: 'dummies-app.template.html',
  styleUrls: ['dummies-app.styles.scss'],
})
export class DummiesAppComponent implements OnInit {
  constructor(private ui: UiService) {}
  ngOnInit() {
    this.ui.app.setTheme('deep-purple');
    this.ui.sidebar.setActions(sidebarActions);
  }
}
